export const TABBED_GRID_SECTION_CLASS = 'flex w-full flex-col gap-4';

export const TABBED_GRID_LIST_CLASS =
	'grid list-none grid-cols-2 gap-2 p-0 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5';
